@if (canWrite() && !showForm()) {
  <div class="d-flex justify-content-end mb-3">
    <button type="button" class="btn btn-sm btn-white" (click)="openForm()">
      <i class="fe fe-plus me-1"></i> Registar evidência
    </button>
  </div>
}

@if (showForm()) {
  <div class="border rounded p-3 mb-3">
    <app-evidence-draft [(draft)]="draft" [editing]="editingId() !== null" />
    <!-- A entrada de seguimento que trouxe a evidência. Quem a regista a partir do seguimento
         já a traz preenchida; aqui dá para a associar ou corrigir depois (revisão de 2026-10-13). -->
    @if (followUps().length) {
      <div class="row g-3 mt-0">
        <div class="col-md-8">
          <label class="form-label">Entrada de seguimento <span class="text-muted small">(opcional)</span></label>
          <select class="form-select" [(ngModel)]="draftFollowUpId" data-no-filter>
            <option [ngValue]="null">— nenhuma</option>
            @for (entry of followUps(); track entry.id) {
              <option [ngValue]="entry.id">
                {{ entry.entryDate | date: 'dd/MM/yyyy' }} — {{ entry.description | slice: 0 : 70 }}{{ entry.description.length > 70 ? '…' : '' }}
              </option>
            }
          </select>
        </div>
      </div>
    }
    @if (error()) { <div class="alert alert-danger small py-2 mt-3 mb-0">{{ error() }}</div> }
    <div class="d-flex justify-content-end gap-2 mt-3">
      <button type="button" class="btn btn-sm btn-white" (click)="cancelForm()">Cancelar</button>
      <button type="button" class="btn btn-sm btn-primary" (click)="save()" [disabled]="saving()">
        {{ saving() ? 'A guardar…' : (editingId() === null ? 'Guardar evidência' : 'Guardar') }}
      </button>
    </div>
  </div>
} @else if (error()) {
  <div class="alert alert-danger small py-2">{{ error() }}</div>
}

@if (evidences().length === 0) {
  <p class="text-muted mb-0">
    Sem evidências registadas. Cada evidência tem data, descrição e os ficheiros que a suportam.
  </p>
} @else {
  @for (evidence of evidences(); track evidence.id) {
    <div class="border rounded p-3 mb-3">
      <div class="d-flex align-items-start gap-3">
        <span class="avatar avatar-sm">
          <span class="avatar-title fs-lg rounded bg-warning-soft text-warning"><i class="fe fe-file-text"></i></span>
        </span>
        <div class="flex-grow-1 min-w-0">
          <span class="fw-bold d-block occ-prewrap">{{ evidence.description }}</span>
          <span class="small text-muted">
            {{ evidence.evidenceDate | date: 'dd/MM/yyyy' }} · {{ evidence.createdByName }}
          </span>
          <!-- De que entrada de seguimento veio: "quando associada a uma ação seria possível
               visualizar esta associação" (revisão de 2026-10-13). -->
          @if (evidence.followUpId) {
            <span class="small d-block mt-1 text-info">
              <i class="fe fe-activity me-1"></i>
              Do seguimento de {{ evidence.followUpEntryDate | date: 'dd/MM/yyyy' }}
              @if (evidence.followUpDescription) {
                <span class="text-muted">— {{ evidence.followUpDescription | slice: 0 : 90 }}{{ evidence.followUpDescription.length > 90 ? '…' : '' }}</span>
              }
            </span>
          }
          @if (evidence.notes) { <p class="mb-0 mt-2 occ-prewrap">{{ evidence.notes }}</p> }
        </div>
        @if (canWrite()) {
          <div class="d-flex gap-1 flex-shrink-0">
            <label class="btn btn-sm btn-white mb-0" title="Anexar ficheiros">
              <i class="fe fe-upload me-1"></i>
              {{ uploading() === evidence.id ? 'A enviar…' : 'Anexar' }}
              <input type="file" multiple hidden (change)="onFilesSelected($event, evidence.id)"
                     [disabled]="uploading() !== null" />
            </label>
            <button type="button" class="btn btn-sm btn-white" (click)="openEdit(evidence)" title="Editar evidência">
              <i class="fe fe-edit-2"></i>
            </button>
            <button type="button" class="btn btn-sm btn-white" (click)="askRemove(evidence)" title="Remover evidência">
              <i class="fe fe-trash-2"></i>
            </button>
          </div>
        }
      </div>
      @if (evidence.attachments.length) {
        <div class="list-group list-group-flush mt-2">
          @for (att of evidence.attachments; track att.id) {
            <div class="list-group-item px-0 py-2 d-flex align-items-center gap-3">
              <span class="avatar avatar-sm">
                <span class="avatar-title fs-lg rounded bg-warning-soft text-warning"><i class="fe" [class]="fileIcon(att.contentType)"></i></span>
              </span>
              <div class="flex-grow-1 min-w-0">
                @if (att.downloadUrl) {
                  <a [href]="att.downloadUrl" target="_blank" rel="noopener" class="fw-bold d-block text-truncate">{{ att.fileName }}</a>
                } @else {
                  <span class="fw-bold d-block text-truncate">{{ att.fileName }}</span>
                }
                <span class="small text-muted">{{ formatSize(att.fileSize) }} · {{ att.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
              </div>
              @if (canWrite()) {
                <button type="button" class="btn btn-sm btn-white" (click)="askRemoveAttachment(att)" title="Remover ficheiro">
                  <i class="fe fe-trash-2"></i>
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  }
}

@if (pendingAttachmentRemoval(); as attachment) {
  <app-confirm-dialog
    title="Remover ficheiro"
    [message]="'O ficheiro &quot;' + attachment.fileName + '&quot; deixa de estar ligado a esta evidência.'"
    confirmLabel="Remover"
    [danger]="true"
    (confirm)="confirmRemoveAttachment()"
    (cancel)="pendingAttachmentRemoval.set(null)"
  />
}

@if (pendingRemoval(); as evidence) {
  <app-confirm-dialog
    title="Remover evidência"
    [message]="'A evidência &quot;' + evidence.description + '&quot; e os ficheiros que lhe pertencem são removidos.'"
    confirmLabel="Remover"
    [danger]="true"
    (confirm)="confirmRemove()"
    (cancel)="pendingRemoval.set(null)"
  />
}
